import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Merge Tailwind classes safely, resolving conflicts (e.g. p-4 + p-6 → p-6).
 * Use this everywhere conditional or composed class strings are needed.
 *
 * @example
 * cn('px-4 py-2', isActive && 'bg-gold-500', className)
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
